

































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import { DateTime } from "luxon";
import _ from "lodash";
import { RatePlansForOfficialRatesExport } from "@/shared/models/accomodationUnitTypeViewModel";
import { Getter } from "vuex-class";
import RichTextEditor from "@/components/misc/RichTextEditor.vue";
import { PropertySpecialNotes } from "@/shared/models/property";
import DateField from "@/components/misc/DateField.vue";
import { saveFile } from "@/shared/saveFile";
import { LanguageView } from "@/shared/models/languages";

const flagImages = require.context("@/assets/images/flags/", false, /\.png$/);

@Component({
  components: { RichTextEditor, DateField },
})
export default class OfficialRatesExportForGuests extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @Prop() propertyId?: number;
  @Prop() accUnitTypeId?: number;

  @Getter("language/supportedLanguages") supportedLanguages?: LanguageView[];

  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;

  loading = false;

  selectedYear = DateTime.now().year;
  years = _.range(DateTime.now().year + 4, DateTime.now().year - 1, -1);

  ratePlansForExport = [] as RatePlansForOfficialRatesExport[];
  selectedRatePlans = [] as number[];

  specialNotes: PropertySpecialNotes[] = [];

  firstLanguageCultureCode = "";
  secondLanguageCultureCode = "";

  firstLanguageSpecialNote = "";
  secondLanguageSpecialNote = "";

  validFrom = "";

  editorToolbar = [
    [{ size: ["16px", "32px", "24px", "18.7px", "14px", "12px"] }],
    ["bold", "italic", "underline"],
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }],
  ];

  saveSpecialNotes = true; //true by default
  separateBySections = false;

  @Watch("internalOpen")
  onOpenChanged(fresh: boolean) {
    if (fresh) {
      this.loadRatePlans();
      this.loadSpecialNotes();
    }
    this.firstLanguageSpecialNote = "";
    this.secondLanguageSpecialNote = "";
    this.firstLanguageCultureCode = "";
    this.secondLanguageCultureCode = "";
    this.validFrom = "";
    this.selectedRatePlans = [];
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  loadRatePlans() {
    this.loading = true;
    this.axios
      .get<ListModel<RatePlansForOfficialRatesExport>>(
        "/AccomodationUnitTypes/" +
          this.accUnitTypeId +
          "/ratePlansForOfficialRatesExport"
      )
      .then((res) => {
        this.ratePlansForExport = res.data.result;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  loadSpecialNotes() {
    this.loading = true;
    this.axios
      .get<ListModel<PropertySpecialNotes>>(
        "/Properties/" + this.propertyId + "/propertySpecialNotes"
      )
      .then((res) => {
        this.specialNotes = res.data.result;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  imgSrc(lang: string) {
    return flagImages("./" + lang + ".png");
  }

  isFormValid = false;

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      requiredArray: [
        (value: any[]) => value.length > 0 || this.$t("Validation.Required"),
      ],
    };
  }

  async exportOfficialRates() {
    this.form.validate();

    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }
    const request = {
      accUnitTypeId: this.accUnitTypeId,
      propertyId: this.propertyId,
      ratePlanIds: this.selectedRatePlans.join(","),
      year: this.selectedYear,
      firstLanguageCultureCode: this.firstLanguageCultureCode,
      secondLanguageCultureCode: this.secondLanguageCultureCode,
      firstLanguageSpecialNote: this.firstLanguageSpecialNote,
      secondLanguageSpecialNote: this.secondLanguageSpecialNote,
      saveSpecialNotes: this.saveSpecialNotes,
      validFrom: this.validFrom,
      separateBySections: this.separateBySections,
    };
    this.loading = true;
    await this.axios
      .post(
        "AccomodationUnitTypes/" +
          this.accUnitTypeId +
          "/officialRatesExportForGuests",
        request,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? `OfficialRateForGuests.pdf`);
        this.loadSpecialNotes();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  languageChanged(first: boolean, event: string) {
    const specialNote = this.specialNotes.find((x) => x.cultureCode === event);
    if (specialNote) {
      if (first) {
        this.firstLanguageSpecialNote = specialNote.note;
      } else {
        this.secondLanguageSpecialNote = specialNote.note;
      }
    } else {
      if (first) {
        this.firstLanguageSpecialNote = "";
      } else {
        this.secondLanguageSpecialNote = "";
      }
    }
  }
}
